module.exports = __webpack_public_path__ + "static/media/thati_lopes.797f4031.png";